import Argent from '@arkade/argent'
import axios from 'axios'
import { regions, BASE_REGION, KEY_NAMES } from '../../constants.js'

// Base currency based on Shopify active currency
const BASE_CURRENCY = Shopify.currency.active

const resolveGeoCountryCode = () =>
  axios
    // API key borrowed from geolizr plugin
    .get('https://pro.ip-api.com/json/?fields=countryCode&key=radCr6mbnqmQcFQ')

    // tRmURnXYvSzbKKY
const resolveCurrencyFromCountry = country => {
  const EUR_COUNTRIES = [
    'FR',
    'IT',
    'DE',
    'ES',
    'NL',
    'CH',
    'RU',
    'IE',
    'SE',
    'NO',
    'BE',
    'GR',
    'FI',
    'DK',
    'AT',
    'PT',
    'PL',
    'UA',
    'LV',
    'IS',
    'LU',
    'BG',
    'MT',
    'CZ',
    'RO',
    'JE',
    'SK',
    'HU',
    'AL',
    'HR',
  ]

  if (EUR_COUNTRIES.includes(country)) {
    return 'EUR'
  }

  if ('CA' === country) {
    return 'CAD'
  }

  if ('US' === country) {
    return 'USD'
  }

  if ('AU' === country) {
    return 'AUD'
  }

  if ('NZ' === country) {
    return 'NZD'
  }

  if ('GB' === country) {
    return 'GBP'
  }

  return BASE_CURRENCY
}

export default async () => {
  const argent = new Argent({
    rates: Currency.rates, // https://cdn.shopify.com/s/javascripts/currencies.js
    baseCurrency: BASE_CURRENCY,
    baseFormat: '0,0',
    formats: {
      // https://www.npmjs.com/package/@arkade/argent
      NZD: {
        symbol: '$',
        code: 'NZD',
      },
      JPY: {
        symbol: '¥',
        code: 'JPY',
      },
    },
  })

  // Attach to window for deep component access
  window.argent = argent

  // Try get the currency based on the visitor's location
  if (!localStorage.getItem('currency') || !localStorage.getItem(KEY_NAMES.visitorCountry)) {
    const geo = await resolveGeoCountryCode().then(response => {
      return {
        currency: resolveCurrencyFromCountry(response.data.countryCode),
        countrycode: response.data.countryCode,
      }
    })
    argent.setCurrency(geo.currency, false)

    localStorage.setItem(KEY_NAMES.visitorCountry, geo.countrycode.toLowerCase())
  }

  // Replace all currencies in the page
  argent.convertFormattedNodes('.currency')

  return argent
}
